import React from 'react';
import Col from 'kepler/lib/components/Col';
import PropTypes from 'prop-types';
import getContent from '../lib/dictionaryFetcher';
import { productsToFPTIMapping } from '../lib/quizStaticMapping';
import { extend, get } from 'lodash';
class UserProductUncollapsed extends React.Component {
  learnMoreFpti = productName => {
    const productSplit = get(productsToFPTIMapping, `${productName}`, '').split(
        ':'
      ),
      { location, fptiHelper } = this.props;
    let fptiOptions = {
      page: 'main:businessweb:mep:dashboard:main:quiz:results',
      link: 'learn_more',
      prod: productSplit[0],
      entry_point: get(location, 'search', '').includes('appcenter=true')
    };
    if (productSplit[1]) extend(fptiOptions, { product_type: productSplit[1] });
    fptiHelper.fptiClick(fptiOptions);
  };
  render() {
    const { toggleProduct, productName, resultData, isCompleted } = this.props;
    return (
      <React.Fragment>
        <div className="results-uncollapsed-cancel results-user-cancel-mobile">
          <button
            className="results-cancel add-focus-visible"
            aria-label={getContent('quiz', 'results.remove')}
            onClick={e => {
              e.preventDefault();
              toggleProduct(productName, true, 'userProducts');
            }}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close results-uncollapsed-cancel-icon" />
          </button>
        </div>
        <Col
          className="icon-user-mobile-container"
          sm="10%"
          style={{ alignSelf: 'flex-start' }}
        >
          <div
            className="results-icon-container"
            style={{
              background: `url(${resultData.icon}) center center/28px 28px no-repeat #FFFFFF`
            }}
          />
        </Col>
        <Col
          className="content-user-mobile-container"
          style={{ paddingLeft: '20px' }}
          sm="80%"
        >
          <h3 className="results-uncollapsed-title">{resultData.header}</h3>
          {isCompleted && (
            <span className="ppvx_badge ppvx_badge--type_success ppvx_badge--status">
              {getContent('quiz', 'results.existingProduct')}
            </span>
          )}
          <p className="results-uncollapsed-subtext">
            {resultData.subText}{' '}
            <a
              target="_blank"
              onClick={() => {
                this.learnMoreFpti(productName);
              }}
              href={resultData.link}
            >
              {getContent('quiz', 'results.product.link')}
            </a>
          </p>
        </Col>
      </React.Fragment>
    );
  }
}
UserProductUncollapsed.propTypes = {
  toggleProduct: PropTypes.func,
  productName: PropTypes.string,
  resultData: PropTypes.object,
  location: PropTypes.object,
  isCompleted: PropTypes.bool,
  fptiHelper: PropTypes.object
};
export default UserProductUncollapsed;
